// extracted by mini-css-extract-plugin
export var layout = "g_x";